import React from "react";
import "./LoadingSpinner.css";

type LoadingSpinnerProps = {
  className?: string;
};

const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({ className }) => {
  return (
    <div
      className={["loading-spinner-container", className].filter(Boolean).join(" ")}
      role="status"
      aria-label="Loading"
    >
      <div className="loading-spinner" />
    </div>
  );
};

export default LoadingSpinner;
